import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import { withTranslation } from "react-i18next";

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const Section3 = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: "Key Features",
    paragraph: ''
  };

  const content = {
      title: "Here's all you'll get in a single platform",
      paragraph: '',
      features: [
        {
          
          text : "Instagram Story Scrapping allows us to know what influencer is working with wich brand",
          icon : "feature-tile-icon-01.svg"
        },
        {
          
          text : "The Discover Influencers Menu allows you to use filters to find the perfect influencers for your company",
          icon : "feature-tile-icon-02.svg"
        },
        {
          
          text : "Analyse Competitor Strategies",
          icon : "feature-tile-icon-03.svg"
        },
        {
          
          text : "Add Influencers / Shops as Favorites",
          icon : "feature-tile-icon-04.svg"
        },
      ]
  };

  const {t, id} = props;

  return (
    <section
      id={id}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>
            {
              content.features.map(item =>{
                return(
                  <div className="tiles-item reveal-from-bottom" key={item.id}>
                    <div className="tiles-item-inner">
                      <div className="features-tiles-item-header">
                        <div className="features-tiles-item-image mb-16">
                          <Image
                            src={require('./../../assets/images/'+item.icon)}
                            alt={"Features-"+item.id}
                            width={64}
                            height={64} />
                        </div>
                      </div>
                      <div className="features-tiles-item-content">
                        <h4 className="mt-0 mb-8">
                          {t("Feature")} {item.id}
                        </h4>
                        <p className="m-0 text-sm">
                          {t(item.text)}
                        </p>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </section>
  );
}

Section3.propTypes = propTypes;
Section3.defaultProps = defaultProps;

export default withTranslation()(Section3);
